/**
 * EditScopeDialog
 * Feature: 005-clinic-scheduling (T025)
 *
 * Dialog asking "This one only" or "This and all future" for recurring events.
 */

import { CalendarDays, CalendarRange } from 'lucide-react'
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Button } from '@/components/ui/button'
import type { EditScope } from '../types/scheduling.types'

interface EditScopeDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description?: string
  onSelect: (scope: EditScope) => void
}

export function EditScopeDialog({
  open,
  onOpenChange,
  title,
  description,
  onSelect,
}: EditScopeDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          {description && (
            <AlertDialogDescription>{description}</AlertDialogDescription>
          )}
        </AlertDialogHeader>

        <div className="space-y-2 py-2">
          <Button
            variant="outline"
            className="w-full justify-start gap-3 h-auto py-3"
            onClick={() => {
              onSelect('this_only')
              onOpenChange(false)
            }}
          >
            <CalendarDays className="h-5 w-5 text-muted-foreground" />
            <div className="text-left">
              <p className="font-medium">Apenas este atendimento</p>
              <p className="text-sm text-muted-foreground">
                Apenas esta ocorrencia sera alterada
              </p>
            </div>
          </Button>

          <Button
            variant="outline"
            className="w-full justify-start gap-3 h-auto py-3"
            onClick={() => {
              onSelect('this_and_future')
              onOpenChange(false)
            }}
          >
            <CalendarRange className="h-5 w-5 text-muted-foreground" />
            <div className="text-left">
              <p className="font-medium">Este e todos os futuros</p>
              <p className="text-sm text-muted-foreground">
                Esta e todas as ocorrencias futuras serao alteradas
              </p>
            </div>
          </Button>
        </div>

        <AlertDialogFooter>
          <AlertDialogCancel>Cancelar</AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
